import React from 'react';
import { GeneralError } from './general-error';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }

    componentDidCatch(error, errorInfo) {
        // Log error to console similar to TanStack Router
        console.error(error, errorInfo);
    }

    render() {
        if (this.state.hasError) {
            return <GeneralError />;
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
